import type { FormAction, CardData, BankData, ApplePayData, DonorInfo } from '../types';
import type { SubmissionError } from '@kuow/core';
import type { DonationForm, ReceiptData, DonationResponse, DonationFrequency } from '@kuow/core';

export const setFormDetails = (formDetails: DonationForm): FormAction => ({
  type: 'SET_FORM_DETAILS',
  payload: formDetails,
});

export const setLoading = (isLoading: boolean): FormAction => ({
  type: 'SET_LOADING',
  payload: isLoading,
});

export const setError = (error: string | null): FormAction => ({
  type: 'SET_ERROR',
  payload: error,
});

export const setSubmissionError = (error: SubmissionError | null): FormAction => ({
  type: 'SET_SUBMISSION_ERROR',
  payload: error,
});

export const setActiveSubscription = (subscription: DonationResponse): FormAction => ({
  type: 'SET_ACTIVE_SUBSCRIPTION',
  payload: subscription,
});

export const setUseNewPaymentMethod = (useNewPaymentMethod: boolean): FormAction => ({
  type: 'SET_USE_NEW_PAYMENT_METHOD',
  payload: useNewPaymentMethod,
});

export const setFrequency = (frequency: DonationFrequency): FormAction => ({
  type: 'SET_FREQUENCY',
  payload: frequency,
});

export const setAmount = (amount: number | null): FormAction => ({
  type: 'SET_AMOUNT',
  payload: amount,
});

export const setCustomAmount = (amount: number | null): FormAction => ({
  type: 'SET_CUSTOM_AMOUNT',
  payload: amount,
});

export const setCoverTheCost = (coverTheCost: boolean): FormAction => ({
  type: 'SET_COVER_THE_COST',
  payload: coverTheCost,
});

export const setGift = (gift: { giftId: number; variantId?: number } | null): FormAction => ({
  type: 'SET_GIFT',
  payload: gift,
});

export const setNoGift = (noGift: boolean): FormAction => ({
  type: 'SET_NO_GIFT',
  payload: noGift,
});

export const setPaymentMethod = (method: string): FormAction => ({
  type: 'SET_PAYMENT_METHOD',
  payload: method,
});

export const setCardData = (cardData: CardData | null): FormAction => ({
  type: 'SET_CARD_DATA',
  payload: cardData,
});

export const setBankData = (bankData: BankData | null): FormAction => ({
  type: 'SET_BANK_DATA',
  payload: bankData,
});

export const setApplePayData = (applePayData: ApplePayData | null): FormAction => ({
  type: 'SET_APPLE_PAY_DATA',
  payload: applePayData,
});

export const setCanMakeApplePay = (canMake: boolean): FormAction => ({
  type: 'SET_CAN_MAKE_APPLE_PAY',
  payload: canMake,
});

export const setMemberId = (memberId: number | null): FormAction => ({
  type: 'SET_MEMBER_ID',
  payload: memberId,
});

export const setDonorInfo = (info: Partial<DonorInfo>): FormAction => ({
  type: 'SET_DONOR_INFO',
  payload: info,
});

export const nextStep = (): FormAction => ({
  type: 'NEXT_STEP',
});

export const prevStep = (): FormAction => ({
  type: 'PREV_STEP',
});

export const setSubmitting = (isSubmitting: boolean): FormAction => ({
  type: 'SET_SUBMITTING',
  payload: isSubmitting,
});

export const setReceipt = (receipt: ReceiptData): FormAction => ({
  type: 'SET_RECEIPT',
  payload: receipt,
});

export const setUtmCampaign = (utmCampaign: string | null): FormAction => ({
  type: 'SET_UTM_CAMPAIGN',
  payload: utmCampaign,
});

